import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

@Component({
  selector: "app-form-file-input-drag",
  templateUrl: "./form-file-input-drag.component.html",
  styleUrls: ["./form-file-input-drag.component.scss"],
})
export class FormFileInputDragComponent implements OnInit {
  @Input("progress")
  set setProgress(progress: number) {
    if (progress) {
      this.progress = progress;
    }
  }

  @Input() title: string;
  @Input() fieldControl: UntypedFormControl;
  @Input() fileInputId: string;
  @Input() parentForm: UntypedFormGroup;
  @Output() fileUploadEvent = new EventEmitter<File>();
  @Output() fileInputCompleteEvent = new EventEmitter();

  dragOver: boolean;
  fileName: string;
  formGroup: UntypedFormGroup;
  progress: number;
  progressComplete: boolean;
  progressError: boolean;
  showProgressBar: boolean;

  ngOnInit() {
    this.formGroup = new UntypedFormGroup({});
  }

  openFileDialog() {
    document.getElementById(this.fileInputId).click();
  }

  fileUpload(files: FileList) {
    this.fileName = files.item(0).name;
    this.showProgressBar = true;

    this.fileUploadEvent.emit(files.item(0));
  }

  infoBarComplete() {
    this.progressComplete = true;

    this.fileInputCompleteEvent.emit();
  }

  restoreUploadFile() {
    this.resetForm();
    this.progressError = false;
    this.showProgressBar = false;
  }

  showErrorUploadFile() {
    this.resetForm();
    this.progressError = true;
  }

  @HostListener("dragover", ["$event"])
  onDragOver(event: DragEvent) {
    this.dragOver = true;
    this.validations(event);
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave(event: DragEvent) {
    this.dragOver = false;
    this.validations(event);
  }

  @HostListener("drop", ["$event"])
  onDrop(event: DragEvent) {
    this.dragOver = true;
    this.validations(event);
  }

  private resetForm() {
    this.fieldControl.setValue("");
    this.formGroup.reset();

    this.progress = 0;
    this.progressComplete = false;
  }

  private validations(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer.files[0]) {
      this.fieldControl.setErrors(null);
      this.fileUpload(event.dataTransfer.files);
    }
  }
}
